var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Classes.ShapeFileLayer = new Class({
    Extends: OCS.Viewer.Classes.VectorLayer,
    debug: false,
    class_name: "ShapeFileLayer",
    options: {
        layer_style_ops: {mask: false},
        style_type: 'shape'
    }
});